<!-- START Footer -->
	<!-- <section class="footer-section"> -->
		<!-- <div class="container"> -->
			<!-- <div class="row bottomlink"> -->
				<!-- <div class="col-sm-5 ptop2em"> -->
					<!-- <h4 class="h2">ABOUT INTERLACE</h4> -->
					<!-- <p style="text-align: justify;"> -->
						<!-- Interlace is not just another IT company you will come across. We mark our difference through our holistic partnership approach with our clients, customers and business partners. Founded in 2007, Interlace has grown in to a multi-faceted End-to-end IT Solutions provider that can deliver customized software products, solutions and IT services to enterprises and government organizations.<a class="more" href="http://interlaceindia.com/index.php/about-us" target="_blank"> more >> </a> -->
					<!-- </p> -->
				<!-- </div> -->
				<!-- <div class="col-sm-3 ptop2em"> -->
					<!-- <h4 class="footer-title">QUICK LINKS</h4> -->
					<!-- <div class="col-sm-12" style="float: left;"> -->
					<!-- <ul> -->
						<!-- <li><a routerLink="/product">Product</a></li> -->
						<!-- <li><a routerLink="/pricing">Pricing</a></li> -->
						<!-- <li><a routerLink="/contact">Book a Demo</a></li> -->
					<!-- </ul> -->
				<!-- </div> -->
			<!-- </div> -->
			<!-- <div class="col-sm-3 ptop2em"> -->
				<!-- <h4 class="footer-title">CONTACT</h4> -->
					<!-- <p style="font-size: 14px;"><span><img src="assets/images/mail.png"></span> ilms[at]interlaceindia[dot]com</p> -->
					<!-- <p><span><img src="assets/images/phone.png"></span>  +91 6380907797</p> -->
					<!-- <div> -->
						<!-- <ul class="social-media"> -->
							<!-- <li><a href="#"> <i class="lab la-facebook-f"></i></a> </li> -->
							<!-- <li><a href="#"><i class="lab la-twitter"></i></a> </li> -->
							<!-- <li><a href="#"><i class="lab la-google-plus"></i></a> </li> -->
							<!-- <li><a href="#"><i class="lab la-instagram"></i></a> </li> -->
						<!-- </ul> -->
					<!-- </div> -->
			<!-- </div> -->
			<!-- </div> -->
			<!-- <hr> -->
			<!-- <div class="col-sm-12  pbtmemem"> -->
				<!-- <p> © 2021 Interlace India Private Limited, All Rights Reserved.</p> -->
			<!-- </div> -->
		<!-- </div> -->
	<!-- </section> -->
<!-- END Footer -->
<!-- <script type="text/javascript" src="assets/scripts/scripts.js"></script> -->

<!-- START Footer -->
    <section class="footer-section ptop1em">
        <div class="container">
            <div class="row">
                <div class="col-sm-6">
                    <p> © 2022 Interlace India Private Limited, All Rights Reserved.</p>
                </div>
                <div class="col-sm-6">
                    <p style="float: right;"><span> <img style="width:22px"
                                src="assets/images/mail.png"></span>
                        ilms@interlaceindia.com &nbsp; &nbsp;
                        <span><img style="width:16px" src="assets/images/phone.png"></span> +91 638 090 7797  &nbsp; / &nbsp; +91 638 090 7244
                    </p>
                </div>
            </div>
        </div>
    </section>
<!-- END Footer -->